import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CustomerAvatar from "@/components/customers/CustomerAvatar";

export default function WaCustomerList({ q, onPick }) {
    const [list, setList] = useState([]);
    useEffect(() => { api.get("/admin/customers").then((r) => setList(r.data)); }, []);
    const s = q.trim().toLowerCase();
    const items = list.filter((c) => !s || `${c.name} ${c.phone}`.toLowerCase().includes(s));

    return (
        <div data-testid="wa-customer-list">
            {items.length === 0 && <div className="p-6 text-center text-xs font-mono text-slate-500">Asnjë klient.</div>}
            {items.map((c) => (
                <button key={c.id} onClick={() => onPick(c)} className="w-full text-left px-3 py-2.5 border-b border-slate-100 flex gap-3 items-center hover:bg-slate-50" data-testid={`wa-customer-${c.id}`}>
                    <CustomerAvatar customer={c} size={36} />
                    <span className="min-w-0">
                        <b className="block text-sm truncate">{c.name}</b>
                        <span className="block text-[11px] font-mono text-slate-500">{c.type === "service" ? "Servis" : "Klient fundor"} · {c.phone}</span>
                    </span>
                </button>
            ))}
        </div>
    );
}
